/* eslint-disable prettier/prettier */
import axios from "axios";
import { BASE_URL, TIMEOUT } from "./config";
import { Toast } from 'vant';

import { getEquipment } from "../utils/index";
import _this from '../main.js'

import Router from "../router";
import L from '../locales';
const l = L.request;

let showError = true;
const instance = axios.create({
	baseURL: BASE_URL,
	timeout: TIMEOUT
});
const queryUrl = (data) => {
	let str = '?'
	for (let key in data) {
		str += `${key}=${data[key]}&`
	}
	str = str.slice(0, str.length - 1)
	return str
}
// 设备类型
let system = "";
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //alert(navigator.userAgent);
    // alert("这是IOS");
    system = "ios";

} else if (/(Android)/i.test(navigator.userAgent)) {
    //alert(navigator.userAgent);
    // alert("这是Android");
    system = "android";
} else {
    // alert("这是PC");
    system = "other";
}
axios.defaults.timeout = 10000;
axios.defaults.headers["Content-Type"] = "application/json"; //设置默认提交 json

axios.defaults.transformRequest = data => JSON.stringify(data);   //把数据对象序列化成 json字符串

instance.interceptors.request.use(config => {
	// 设置加载进度条(开始..)
	if(!config.isShowUnloading){
		Toast.loading({
			message: l.req_loading,
			forbidClick: true,
			duration: 0
		});
	}
	try {
		showError = config?.data?.showError ?? true;
		config?.data && (delete config.data.showError)
	} catch (e) {
		console.log(e)
	}
	const userResult = _this.$store.state.user.userInfo;
	let params = {
		"timestamp": Date.now(),
		"referrer": "utm_source="+localStorage.getItem("channel"),
		// "af_prt": "channel\u003d"+sessionStorage.getItem("channel"),
		"af_prt": localStorage.getItem("channel"),
		"sign": "0f656af82eb1da33221a06d1171db265",
		// "pkg_name": "com.loan.yizhunh5",
		// "imei": "862209031257508",
      "appversion": "1.0.0",
      channel: "1",
      "app_version": "1.0.0",
      "version": "1.0.0",
	}

	if(process.env.VUE_APP_GENRE === "nested") {
		let visitorId = localStorage.getItem("visitorId");
		params.imei = visitorId;
		params.uuid = visitorId;
		params.pkg_name = userResult.pkg_name;
	}else{
		let visitorId = localStorage.getItem("visitorId");
		params.imei = visitorId;
		params.uuid = visitorId;
		if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
			params.pkg_name = "com.loan.yizhunh5ios";
		} else if (navigator.userAgent.match(/android/i)) {
			params.pkg_name = "com.loan.yizhunh5";
		}
	}

	// console.log("设备类型",system);
    if (userResult?.phone) {
		params.account_id = userResult.phone;
	}
	if(userResult?.user_id){
		params.user_id = userResult.user_id;
	}
	if(userResult?.imei){
		params.imei = userResult.imei;
	}
	if(userResult?.loginStaticKey){
		params.loginStaticKey = userResult.loginStaticKey;
	}
	
	if(userResult?.version){
		params.app_version = userResult.version;
		params.appversion = userResult.version;
		params.version = userResult.version;
	}
	config.data = Object.assign(config.data || {}, params);
	// 1.发送网络请求时, 在界面的中间位置显示Loading的组件
	// 2.某一些请求要求用户必须携带token, 如果没有携带, 那么直接跳转到登录页面
	// const token = sessionStorage.getItem("token");
	// token && (config.headers["token"] = token);
	const channel = localStorage.getItem("channel");
	config.headers["channel"] = channel ?? '';
	const Language = sessionStorage.getItem("Language");
	config.headers["Content-Language"] = Language; //设置语言
	config.headers["system"] = system; //设置默认提交 json
	config.headers["deviceType"] = "h5"; //设置默认提交 json
	// 设备信息
	let deviceData = sessionStorage.getItem("deviceData");
	if (deviceData) {
		try {
			deviceData = JSON.parse(deviceData||"{}");
		} catch (e) {
			console.log(e)
		}
	}
	if (!deviceData) {
		deviceData = getEquipment();
		sessionStorage.setItem("deviceData", JSON.stringify(deviceData))
	}
	deviceData.userAgent = undefined;
	Object.keys(deviceData)?.map(v => {
		deviceData[v] && (config.headers[(v).toLocaleLowerCase()] = deviceData[v]);
	})
	if (config.method === 'get') {
		// config.url
		config.url = config.url + queryUrl(config.data)
		config.data = {}
	}
	// 3.params/data序列化的操作
	return config;
}, err => {
	console.log(err)
});

instance.interceptors.response.use(res => {
	Toast.clear();
	// 设置加载进度条(结束..)
	if (res?.data?.code != 200) {
		// 错误
		if(["600908","600928","600929"].includes(res?.data?.code)){
			_this.$store.commit("LOGOUT_MOVE_USER_INFO");
			if(process.env.VUE_APP_GENRE === "nested") {
				_this.$tools.androidMethod("signOut", {}, "");
			}else{
				localStorage.removeItem('userInfo');
				localStorage.removeItem("vic_mall");
				Router.push('/login')
			}

			return res.data;
		}
		if (showError) {
			Toast.fail(res.data.message);
		}
		return Promise.reject(res.data);
	}
	return res.data;
}, err => {
	Toast.clear();
	if (err && err.response) {
		Toast.fail(JSON.stringify(err.message));
		switch (err.response.status) {
			case 400:
				console.log("请求错误");
				break;
			case 401:
				console.log("未授权访问");
				break;
			default:
				console.log("其他错误信息");
		}
	} else {
		console.log("请求错误");
		if (showError) {
			// 自义定展不展示错误toast 不是原生 对不起
			// Toast.fail(l.req_error);
			Toast.fail(JSON.stringify(err.message));
		}
	}
	return err;
});

export default instance;

